import { Injectable } from "@angular/core";
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { GET_OPENSTOCKVIEW } from "../../../data/definitions/warehouse-definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { GetOpenStockViewQuery, GetOpenStockViewQueryVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class OpenStockViewService extends BaseListService {

    constructor(private dataService: DataService,
        private baseDataService: BaseDataService,
        private systemService: SystemService) {
        super();
    }

    getItems(searchInput?: SearchInput) {

        let fragment = GET_OPENSTOCKVIEW;

        return this.baseDataService.query<GetOpenStockViewQuery, GetOpenStockViewQueryVariables>(
            fragment, {
            input: searchInput as any
        });
    }

    //moved to own service
    // getOpenStockViewSum(searchInput?: OpenStockViewSumSearchInput) {

    //     let fragment = GET_OPENSTOCKVIEWSUM;

    //     return this.baseDataService.query<GetOpenStockViewSum.Query, GetOpenStockViewSum.Variables>(
    //         fragment, {
    //         input: searchInput
    //     }).mapSingle(x => x.getOpenStockViewSum);
    // }
}
